import { Avatar, Flex, Typography } from 'antd';
import type { Campaign, TableData } from '@/types';
import { formatCurrency } from '@/utils/currencyUtils';

const notApplicable = (
  <Typography.Text type="secondary" style={{ fontSize: 'inherit' }}>
    n/a
  </Typography.Text>
);

/**
 * Builds Ant Design–compatible row data for the campaigns table.
 * Mirrors {@link TableContent} for Echo surfaces.
 */
const TableContentEcho = (campaigns: Campaign[]): TableData[] =>
  campaigns.map((campaign) => ({
    id: campaign.id,
    columns: [
      {
        id: 'show_name',
        value: (
          <Flex align="center" gap={8}>
            <Avatar
              shape="square"
              size={40}
              src={campaign.show.image_url ?? undefined}
              alt={`${campaign.show.name} Thumbnail`}
              style={{ flexShrink: 0 }}
            />
            <Typography.Text strong style={{ whiteSpace: 'normal' }}>
              {campaign.show.name}
            </Typography.Text>
          </Flex>
        ),
      },
      {
        id: 'brand',
        value: campaign.brand || notApplicable,
      },
      {
        id: 'campaign_type',
        value: campaign.type.name,
      },
      {
        id: 'campaign_start_at',
        type: 'date',
        value: campaign.start_at || notApplicable,
      },
      {
        id: 'campaign_end_at',
        type: 'date',
        value: campaign.end_at || notApplicable,
      },
      {
        id: 'impressions',
        type: 'number',
        value:
          campaign.impressions === null
            ? notApplicable
            : (campaign.impressions?.toLocaleString() ?? '0'),
        style: { textAlign: 'right' },
      },
      {
        id: 'amount',
        type: 'number',
        value: formatCurrency(campaign.total.amount, campaign.total.currency),
        style: { textAlign: 'right' },
      },
    ],
  }));

export default TableContentEcho;
